<template>
  <v-row class="primary pa-5 mb-5">
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Nome</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.nome | textoSemValor }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Razão Social</span>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <p v-on="on" class="mb-0 text-truncate">{{ dadosGerais.razaoSocial | textoSemValor }}</p>
        </template>
        {{ dadosGerais.razaoSocial | textoSemValor }}
      </v-tooltip>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Tipo Pessoa</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.tipoPessoa | filterEnum(tipoPessoa) }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">CPF/CNPJ</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.cnpjCpf | formatarCpfCnpj }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Inscrição Estadual</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.inscricaoEstadual | textoSemValor }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Telefone</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.telefone | formatarTelefone }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">E-mail</span>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <p v-on="on" class="mb-0 text-truncate">{{ dadosGerais.email | textoSemValor }}</p>
        </template>
        {{ dadosGerais.email | textoSemValor }}
      </v-tooltip>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Município</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.municipioNome | textoSemValor }}</p>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Rua</span>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <p v-on="on" class="mb-0 text-truncate">{{ dadosGerais.logradouro | textoSemValor }}</p>
        </template>
        {{ dadosGerais.logradouro | textoSemValor }}
      </v-tooltip>
    </v-col>
    <v-col class="headerCabecalho pr-0" md="2" sm="2" xs="6">
      <span class="font-weight-bold">Número</span>
      <p class="mb-0 text-truncate">{{ dadosGerais.logradouroNumero | textoSemValor }}</p>
    </v-col>
  </v-row>
</template>

<script>
import tipoPessoa from '@/core/constants/enums/tipoPessoa'

export default {
    name: 'ParametrosCabecalho',
    props: {
        dadosGerais: Object,
    },
    data() {
        return {
            tipoPessoa
        }
    }
}
</script>

<style scoped lang="stylus">

.container-parametros
  padding-top 0

  span
    font-weight bold
    color var(--theme-primary)

.headerCabecalho
  font-size 0.9em
  color white
  max-height 90px

</style>